import { axiosEduServer } from "../utils/configAxios";

export const crearNivel = (data) => {
  return axiosEduServer.post('/nivel', data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const actualizarNivel = (id, data) => {
  return axiosEduServer.put(`/nivel/${id}`, data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const eliminarNivel = (id) => {
  return axiosEduServer.delete(`/nivel/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getOneNivel = (id) => {
  return axiosEduServer.get(`/nivel/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllNiveles = () => {
  return axiosEduServer.get('/nivel').then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllNivelesByIdIdioma = (idIdioma) => {
  return axiosEduServer.get(`/idioma/ididioma/${idIdioma}/niveles`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};